import {createContext} from 'react';
import {CheckboxPlacement} from './types';

export type SelectableListContextState<T> = {
	toggleValue: (value: T) => void;
	value: T[];
	checkboxPlacement: CheckboxPlacement;
};

const SelectableListContext = createContext<SelectableListContextState<any>>(null);
export default SelectableListContext;
